import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AlertContainerComponent } from '@shared/components/alert-container';
import { LoadingOverlayComponent } from '@shared/components/loading-overlay';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AlertContainerComponent, LoadingOverlayComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected readonly title = signal('cbb-logistica-frontend');
}
